import React, { Component } from 'react';
import './css/upload-lightbox.css';

class UploadLightbox extends Component {
	constructor(props){
		super(props)
		this.state = {
			isVisible : true,
			inProgressUploads : {},
			n : "72%"
		};
		this.dismissUploadLightbox = this.dismissUploadLightbox.bind(this);
		this.uploadFileProgressIndicator = this.uploadFileProgressIndicator.bind(this);
		this.handlerDrop = this.handlerDrop.bind(this);
		this.doUploadFile = this.doUploadFile.bind(this);
		this.doUploadFiles = this.doUploadFiles.bind(this);
	}

	componentDidMount() {
	}

	componentWillUnmount() {
	}

	dismissUploadLightbox(){
		this.props.fnDismiss();
	}

	uploadFileProgressIndicator(myKey, myBadge, myCaption, myProgress){
		let r =
		<div key={myKey} className="opta-upload-progress" >
			<div className={"opta-badge " + myBadge}/>
			<div className="opta-caption">{myCaption}</div>
			<div className="opta-progress">{myProgress + "%"}</div>
		</div>
		return r;
	}

	doUploadFile(f){
		var d = new Date();
		var key = d.getTime();

		this.setState( (prevState, props) => {
			prevState.inProgressUploads[key] = {key: key, badge: "", caption: f.name, completed: 0 };
			return { inProgressUploads : prevState.inProgressUploads };
		} );

		var xhr = new XMLHttpRequest();
		this.setState( (prevState, props) => {
			prevState.inProgressUploads[key]["badge"] = "inprogress";
			return { inProgressUploads : prevState.inProgressUploads };
		});


		xhr.upload.onabort = ()=>{console.log("@xhr.upload.onabort");};
		xhr.upload.onerror = ()=>{ console.log("@xhr.upload.onerror"); };
		xhr.upload.onload = ()=>{ console.log("@xhr.onload"); };
		xhr.upload.onloadstart = ()=>{ console.log("xhr.onloadstart"); };
		xhr.upload.onloadend = ()=>{ console.log('@xhr.onloadend'); };
		xhr.upload.ontimeout = ()=>{console.log("@xhr.upload.timeout");};
		xhr.onerror = ()=>{ console.log('@xhr.onerror'); };

		xhr.upload.onprogress = (evt)=>{
			if (evt.lengthComputable) {
				var percentComplete = Math.round(100 * evt.loaded / evt.total);
				this.setState((prevState, props) => {
					prevState.inProgressUploads[key]['completed'] = percentComplete;
					//console.log("Setting progress for %s to %d", prevState.inProgressUploads[key].caption, percentComplete);
					return { inProgressUploads : prevState.inProgressUploads };
				});
			} else {
				// Unable to compute progress information since the total size is unknown
			}
		};

		xhr.onreadystatechange = (e) => {
			var me = e.target;
			//console.log("@xhr.onreadystatechange: %o", e);
			//console.log("this.readyState: "+ me.readyState);
			//console.log("this.status: "+ me.status);

			if (me.readyState === 4){
				//console.log("XHR completed");
				if (me.status === 200) {
					//console.log("XHR Success");
					if (me.responseText === "\"Success\""){
						console.log("XHR Server says Success! " + me.thefilename);
						this.setState( (prevState, props) => {
							prevState.inProgressUploads[key]["badge"] = "completed";
							return { inProgressUploads : prevState.inProgressUploads };
						});						
						setTimeout(function(){
							alert(window.l10n[window.locale]["upload.upload-success"] + "\n" + me.thefilename);
						}, 100);
					} else {
						//console.log("XHR error - Server did not acknowledge: %o", me.responseText);
						this.setState( (prevState, props) => {
							prevState.inProgressUploads[key]["badge"] = "error";
							return { inProgressUploads : prevState.inProgressUploads };
						});
					}
				} else {
					//console.log("XHR Completed but with an error.");
					this.setState( (prevState, props) => {
						prevState.inProgressUploads[key]["badge"] = "error";
						return { inProgressUploads : prevState.inProgressUploads };
					});
					setTimeout(function(){
						var errMessage = "\n\nError Status: " + me.status + ": " + me.responseText;
						alert(window.l10n[window.locale]["upload.upload-failure"] + errMessage);
					}, 100);
				}
			}
		};


		xhr.open('post', window.AppConfig["url-upload"], true);


		var formData = new FormData();

		formData.append('userfile', f );
		formData.append('useroem', this.props.useroem);
		formData.append('optatoken', window.optaToken + window.optaAdminToken);

		console.log("sending file... %o", f);
		xhr.thefilename = f.name;
		xhr.send(formData);
	}

	handlerDrop(e){
		e.preventDefault();
		var lstFiles = e.dataTransfer.files;
		//([...lstFiles]).forEach( f => { console.log("Filename : %o", f.name); } )
		this.doUploadFiles( lstFiles );
	}

	doUploadFiles(files){
		//if (files) ([...files]).forEach(this.doUploadFile);
		for (var i = 0; i < files.length; i++) {
		  this.doUploadFile(files[i]);
		}
		this.value = null;
	}

	render() {
		let theUploads = [];
		for (var i in this.state.inProgressUploads){
			var u = this.state.inProgressUploads[i];
			theUploads.push( new this.uploadFileProgressIndicator(u.key, u.badge, u.caption, u.completed));
		}
		//<input type="file" id="file-input" onChange={ (e)=>{ this.doUploadFiles(e.target.files)} } />
		/*
		<form name="form1" method="post" encType="multipart/form-data" action={window.AppConfig["url-upload"]}>
		  <label htmlFor="file">Filename:</label>
		  <input type="file" name="file" id="file" />
		  <input type="submit" />
		</form>
		*/
		return (
			<div className="lessee-upload-lightbox"
				onDrop 		=	{ this.handlerDrop }
				onDragOver 	= 	{ (e)=>{e.preventDefault()}}
				onDragEnter =	{ (e)=>{e.preventDefault()}}
				onDragLeave	=	{ (e)=>{e.preventDefault()}}
			>
				<div className="dialog" >
					<div className="frame">
						<div className="upload-logo"/>
						<button className="close-btn" type="image" onClick={this.dismissUploadLightbox}/>
						<div className="txt">
						{ window.l10n[window.locale]["upload.uploadyourdoc"] }
							<div className="txt1">
							{ window.l10n[window.locale]["upload.draganddrop"] }
							</div>
							<div className="txt2">
							{window.l10n[window.locale]["upload.or"]}
							</div>
							<label htmlFor="file-input" className="browse-btn">
								<div>{window.l10n[window.locale]["upload.browsefiles"]}</div>
								<input type="file" name="file" id="file-input" onChange={ (e)=>{ this.doUploadFiles(e.target.files)} } multiple/>
							</label>
						</div>
					</div>
				</div>
				{ theUploads }
			</div>
		);
	}
}
export default UploadLightbox;



// WEBPACK FOOTER //
// ./src/components/upload-lightbox.js